import React from "react";
import { TableRow, TableCell, Checkbox } from "@mui/material";
import EzControlledCheckBoxWithLabel from "../../../../../common/EzForm/EzControlledCheckBox/WithLabel";
import "../index.css";

const UserAccessSubRow = ({ sub, control, errors, handleChange }) => {
  const trimmedTitle = sub?.title?.trim() || "";
  const isNew = trimmedTitle.endsWith("New");
  const displayTitle = trimmedTitle.replace(/\s+New$/, "");

  return (
    <TableRow>
      <TableCell className="table-cell submodule-title-cell">
        {displayTitle} {isNew && <span className="new-badge">New</span>}
      </TableCell>
      <TableCell className="table-cell permission-cell">
        <EzControlledCheckBoxWithLabel
          name={sub.title}
          value={sub.view}
          control={control}
          isError={errors[sub.title]}
          labelClassName={"mr-2"}
          onChange={(e) => handleChange(sub.menuId, "view", e.target.checked)}
        />
      </TableCell>
      <TableCell className="table-cell permission-cell">
        <EzControlledCheckBoxWithLabel
          name={sub.title}
          value={sub.createCrud}
          control={control}
          isError={errors[sub.title]}
          labelClassName={"mr-2"}
          onChange={(e) =>
            handleChange(sub.menuId, "createCrud", e.target.checked)
          }
        />
      </TableCell>
      <TableCell className="table-cell permission-cell">
        <EzControlledCheckBoxWithLabel
          name={sub.title}
          value={sub.editCrud}
          control={control}
          isError={errors[sub.title]}
          labelClassName={"mr-2"}
          onChange={(e) =>
            handleChange(sub.menuId, "editCrud", e.target.checked)
          }
        />
      </TableCell>
    </TableRow>
  );
};

export default UserAccessSubRow;
